import { Resource } from "../resource";

export class TBCBnpl extends Resource {
    orderId: string;
    url:     string;
    
}
export class PaymentMethod extends Resource {
    filename: string;
    name:     string;
    uid: string;
    minValue: number;
    maxValue: number;
}

export class BOGPayment extends Resource{
    status:       string;
    paymentHash: string;
    links:        BOGPaymentLink[];
    orderId:     string;
    paymentMethod: string;
    googlePayToken: string;
    applePayToken: string;
    diagnosticId?: string;
    result: any;
}

export class BOGPaymentLink extends Resource{
    href:   string;
    rel:    string;
    method: string;
}
